module.exports = __webpack_public_path__ + "static/media/RSD02.5dc291f7.jpeg";